import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BaseComponent } from '@core/components/base-component';
import { SortHelper } from '@core/helpers/sort.helper';
import { DepartmentEstimate } from '@interfaces/DepartmentEstimate';
import { Estimate } from '@interfaces/Estimate';
import { TranslateService } from '@ngx-translate/core';
import { EstimateSettingsService } from '@shared/services/estimate-settings.service';
import { EstimateService } from '@shared/services/estimate.service';
import { UserService } from '@shared/services/user.service';
import { Table } from 'primeng/table';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'pop-department-table',
  templateUrl: './department-table.component.html',
  styleUrls: ['./department-table.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class DepartmentTableComponent extends BaseComponent implements OnInit {
  public colspanClassifications = 0;
  public colspanInternalFees = 0;
  public currentEstimate: Estimate;
  public departmentEstimates: DepartmentEstimate[] = [];
  public currentLang: string;
  public activateInternalFees: boolean;

  @Input() public departmentLabel: string;
  @Input() public functionalCurrencySymbol: string;

  public constructor(
    private estimateService: EstimateService,
    private translateService: TranslateService,
    private userService: UserService,
    private estimateSettingsService: EstimateSettingsService
  ) {
    super();
  }

  public ngOnInit() {
    this.subscribe(
      combineLatest({
        estimate: this.estimateService.observeCurrentEstimate(),
        user: this.userService.getUser(),
        settings: this.estimateSettingsService.getEstimateConfiguration()
      }).subscribe(results => {
        this.currentEstimate = results.estimate;
        this.activateInternalFees = results.settings.activateInternalFees;

        this.departmentEstimates = SortHelper.sortArrayByProperty(
          this.currentEstimate.departmentEstimates,
          o => o.department?.code
        ).slice();
        SortHelper.sortArrayByProperty(this.currentEstimate.classificationEstimates, o => o.classification?.code);

        this.colspanClassifications = this.currentEstimate.classificationEstimates.length;
        this.colspanInternalFees = this.currentEstimate.internalResourceEstimates.length;

        this.currentLang = results.user.languageCode ?? this.translateService.currentLang;
      })
    );
  }

  public filterTable(table: Table, eventTarget: EventTarget) {
    const input = eventTarget as HTMLInputElement;
    table.filterGlobal(input.value, 'contains');
  }
}
